import React from "react";

const ADO_Error = () => {
  return (
    <div className="tutorial-page">
      <h1>ADO Error</h1>
      <p>This is the ADO Error page content.</p>
    </div>
  );
};

export default ADO_Error;
